<template>
  <div class="box project-card">
    <div class="box__header">
      <router-link :to="{ name: 'Project', params: { projectId: project.id } }">
        <ProjectProfileImage :project="project" />
      </router-link>
    </div>

    <div class="box__body">
      <div @click="routeToProfile">
        <UserProfileImage
          :profile-pic="project.makerRef ? project.makerRef.profilePic : null"
          class="project-card__profile-image"
        />
      </div>

      <div class="project-card__profile-details">
        <!-- Maker Username -->
        <router-link
          v-if="project.makerRef"
          :to="{ name: 'Profile', params: { userId: project.makerRef ? project.makerRef.id : '' } }"
        >
          <div
            v-if="project.makerRef && project.makerRef.username && project.makerRef.username !== ''"
            class="project-card__username"
          >
            {{ project.makerRef ? project.makerRef.username : 'No Name Provided' }}
          </div>
        </router-link>

        <!-- Project Verified Status -->
        <div v-if="project.isVerified" class="project-card__verified-status">
          <font-awesome-icon icon="check-circle" size="1x" class="verified-icon" />
          <router-link
            v-if="project.approverRef"
            :to="{ name: 'Profile', params: { userId: project.approverRef.id } }"
          >
            Verified by
            {{
              project.approverRef && project.approverRef.username
                ? project.approverRef.username
                : 'Mzingo Partners'
            }}
          </router-link>
          <span v-if="!project.approverRef">Verified by Mzingo Partners</span>
        </div>
      </div>

      <!-- Project Name -->
      <router-link :to="{ name: 'Project', params: { projectId: project.id } }">
        <h3 class="project-card__title">{{ project.title }}</h3>
      </router-link>

      <!-- Project Headline -->
      <div class="box__row" style="justify-content: center;">
        <span class="project-card__headline">{{ project.headline | truncateString }}</span>
      </div>
      <!-- NRS 10.29.2019 -- This is likely to be added back in, so I'm saving it -->
      <!-- <div v-if="userIsLoggedIn && project.mostRecentActiveGoal.id" class="box__row">
          <GoalCard
            :goal="project.mostRecentActiveGoal"
            :owned-by-me="project.ownedByMe"
            :project="project"
            style="margin: 1.5rem 0"
          />
      </div>-->

      <div class="box__row">
        <div class="button-wrapper" style="margin: .5rem 0 0; justify-content: space-around">
          <router-link :to="{ name: 'Project', params: { projectId: project.id } }">
            <button v-if="!project.ownedByMe" class="small-button">Learn More</button>
          </router-link>
          <router-link :to="{ name: 'GoalList', params: { projectId: project.id } }">
            <button v-if="!project.ownedByMe" class="small-button">Give</button>
          </router-link>
        </div>
      </div>

      <!-- RK 11.15.19 - Hidden b/c showing attributes aren't part of new requirements -->
      <!-- <div v-if="userIsLoggedIn" class="box__row">
        <div class="button-wrapper" style="margin: 0rem">
          <div v-if="project.attributesRef.length">
            <div v-for="attribute in project.attributesRef" :key="attribute.id" class="tag">
              {{ attribute.name }}
            </div>
          </div>
        </div>
      </div>-->
    </div>

    <div>
      <div class="box__followers-wrapper">
        <!-- NRS 10.29.2019 -- Hidden at request of CF. We will add this back in once we figure out how to show -->
        <!-- questions instead of questioners -->
        <!-- <h5 class="box__followers" @click="updateTabToShow('questioners')">
            <font-awesome-icon class="orange" icon="comments" size="1x" /> Questions ({{
              project.questionerCount
            }})
        </h5>-->
        <h5 class="box__followers">
          <font-awesome-icon class="orange" icon="users" size="1x" />
          {{ project.followerCount }} {{ project.followerCount === 1 ? 'Follower' : 'Followers' }}
        </h5>
        <h5 class="box__followers">
          <font-awesome-icon class="orange" icon="money-bill-alt" size="1x" />
          {{ project.funderCount }} {{ project.funderCount === 1 ? 'Funder' : 'Funders' }}
        </h5>
      </div>

      <!-- <ActivityDetailCard
          :tab-to-show="tabToShow"
          :project="project"
          @close-detail-card="updateTabToShow('')"
      />-->
    </div>
  </div>
</template>

<script>
// import GoalCard from '@/components/GoalCard'
// import ActivityDetailCard from '@/components/ActivityDetailCard'
import ProjectProfileImage from '@/components/images/ProjectProfileImage'
import UserProfileImage from '@/components/images/UserProfileImage'
import User from '@/services/users'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ProjectCard',
  components: {
    // GoalCard,
    ProjectProfileImage,
    UserProfileImage,
    // ActivityDetailCard,
  },
  filters: {
    truncateString(value) {
      if (!value) return ''
      if (value.length > 500) {
        value = value.substring(0, 500) + '...'
      }
      return value
    },
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tabToShow: null,
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['userIsLoggedIn']),
  },
  methods: {
    updateTabToShow(tabName) {
      if (this.tabToShow === tabName) {
        this.tabToShow = null
      } else {
        this.tabToShow = tabName
      }
    },
    toggleFollowProject(projectId) {
      const fields = ['followingProjects']
      let newUser = User.create(this.user)
      if (this.project.followedByMe) {
        newUser.followingProjects = this.user.followingProjects.filter(p => p.id === projectId)
      } else {
        newUser.followingProjects = this.user.followingProjects
        newUser.followingProjects.push(projectId)
      }
      User.api.update(newUser, fields).then(() => {
        this.project.followedByMe = !this.project.followedByMe
      })
    },
    unverifiedStatusAlarm() {
      this.$Alert.alert({
        message: `
          <h3>Project Status - Unverified</h3>
          <p>Your project is still in our review process! If you haven't heard from your activator more than 3 days after submitting your project, reach out to mzingopartners@gmail.com. See notes from your activator at the top of your project detail page.</p>
          `,
        timeout: 5000,
      })
    },
    routeToProfile() {
      if (this.project.maker) {
        this.$router.push({ name: 'Profile', params: { userId: this.project.maker } })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/layout';
@import '../styles/forms';
@import '../styles/mixins/buttons';

.project-card {
  display: inline-block;
  width: 90%;
  margin-top: -40px;
  margin-bottom: 40px;
  border-radius: 8px;
  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  border: none;

  &__project-image {
    border-radius: 8px 8px 0 0;
  }

  &__profile-image {
    text-align: center;
    cursor: pointer;
  }

  &__profile-details {
    text-align: center;
  }

  &__username {
    font-size: 18px;
    margin: 8px;
    font-weight: 900;
    color: black;
  }

  &__verified-status {
    font-size: 12px;
    line-height: 1.2rem;
    color: $gray;
    margin: 6px;
  }

  &__title {
    text-align: center;
    font-size: 22px;
    line-height: 1.2rem;
    margin-top: 24px;
    color: black;
  }

  &__headline {
    text-align: center;
    font-size: 14px;
    line-height: 1.2rem;
    margin: auto 2rem;
  }
}

.box__followers {
  @media only screen and (max-width: 420px) {
    font-size: 0.85rem;
  }

  @media only screen and (max-width: $mobile-smallest-width) {
    font-size: 0.85rem;
  }
}

.large-button {
  @media only screen and (max-width: $mobile-smallest-width) {
    width: 15rem;
  }
}

h5 {
  display: inline;
}

.verified-icon {
  color: $primary;
  margin-right: 0.2rem;
}
</style>
